import { Link } from 'react-router-dom';
import { categories, mainSiteUrl, articleList } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <span className="text-background-50 font-bold text-sm">K</span>
              </div>
              <span className="font-semibold text-base text-background-50">
                Kakobuy<span className="text-primary-400">Polska</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              Niezależny przewodnik po Kakobuy Spreadsheet dla polskich użytkowników.
              Znajdź najlepsze produkty, poradniki i strategie zakupowe.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
            >
              Odwiedź kaspreadsheet.com
              <i className="ri-arrow-right-up-line text-xs"></i>
            </a>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Popularne Kategorie</h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Więcej Kategorii</h4>
            <ul className="space-y-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Artykuły i Poradniki</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/czym-jest-kakobuy-spreadsheet" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                  Czym jest Kakobuy Spreadsheet?
                </Link>
              </li>
              {articleList.slice(0, 5).map((article) => (
                <li key={article.slug}>
                  <Link to={`/${article.slug}`} className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                    {article.title.split('—')[0].trim()}
                  </Link>
                </li>
              ))}
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                  Kakobuy Spreadsheet
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800/50 mt-8 md:mt-10 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} KakobuyPolska.sbs — Niezależny przewodnik. Nie jesteśmy oficjalną stroną Kakobuy.
          </p>
          <div className="flex items-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer"
            >
              kaspreadsheet.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}